import { Component, ErrorInfo, ReactNode } from "react";
// import styles from "./ErrorMessageDisplay.module.css"; // Reuse existing error styles if possible

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{ padding: "20px", color: "red", textAlign: "center" }}>
          <h3>A apărut o eroare neașteptată.</h3>
          <p>Te rugăm să reîmprospătezi pagina.</p>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <pre style={{ textAlign: "left", fontSize: "10px", overflow: "auto" }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

